angular.module('lf.common')

.directive('lfNumbersOnly', function () {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attrs, ctrl) {
      ctrl.$parsers.unshift(function (val) {
        if (!val) return '';
        var after = val.replace(/[^0-9]/g, ''); 
        if (after !== val) {
          ctrl.$setViewValue(after);
          ctrl.$render();
        }

        return after;
      });
    }
  };
});
